import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withRouter } from 'react-router-dom';
import { themeColors } from 'msp-components';
import { useAnalytics } from 'hooks';
import { rem } from 'utils/text';
import { Helmet } from 'react-helmet';

const StyledContainer = styled.div`
  align-items: center;
  border: 1px solid ${themeColors.grayNickel};
  border-top: none;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  color: ${themeColors.bodyColor};
  font-size: ${rem(16)};
`;

const StyledHeader = styled.header`
  color: ${themeColors.headingColor};

  h1 {
    font-size: ${rem(36)};
    margin: 0;
  }
`;

const Error404 = ({ location, onLoad }) => {
  useEffect(() => onLoad && onLoad(), [onLoad]);

  const { trackEvent } = useAnalytics();
  useEffect(() => {
    const path = location.pathname + location.search;
    trackEvent && trackEvent({
      category: 'error',
      action: 'error-404',
      label: path,
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <StyledContainer>
      <Helmet>
        <title>404 - Page Not Found</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <StyledHeader>
        <h1 className="mb-3">Error 404</h1>
      </StyledHeader>
      <p>
        We’re sorry, but the page you requested could not be found.
      </p>
    </StyledContainer>
  );
};

Error404.propTypes = {
  location: PropTypes.object,
  onLoad: PropTypes.func,
};

export default withRouter(Error404);
